// extracted by mini-css-extract-plugin
module.exports = {"stickyBar":"sticky-scroll-tab_stickyBar__LOm_i","tabBtn":"sticky-scroll-tab_tabBtn__AX97V","active":"sticky-scroll-tab_active__Wu7Y4","section":"sticky-scroll-tab_section__vXE0z"};